import { objectToQueryString } from '../../helpers/objectToQueryString';
import { IGetBrandsResponse } from '../../types/brands';
import { axiosInstance } from '../axiosInstance';

export const getBrands = async (
  params?: Record<string, string | number>,
): Promise<IGetBrandsResponse> => {
  const queryString = params ? objectToQueryString(params) : '';

  const response = await axiosInstance.get(`/brands?${queryString}`);

  return response.data;
};
